module.exports = require("@ember/-internals/runtime");